module.exports = __webpack_public_path__ + "c8b437ef869c6f770011b5d7f85c6e42.jpg";